/**
 * Core
 */
import { ContextProfileUser } from "../../lib/profileContext";
import { useContext, useState } from "react";
import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  validateAge,
  simplyClick,
} from "../../helpers";
import SelectGlobal from "../SelectGlobal";
import ButtonGroup from "../ButtonGroup";

/**
 *Styles
 */
import "./Birthday.scss";
import { errorEventsBirthday } from "../../constants";

const Birthday = ({ setStep, step }) => {
  const { data, setData } = useContext(ContextProfileUser);
  const [errorBirthday, setErrorBirthday] = useState(null);

  const handlerSubmit = () => {
    const {
      status,
      error,
      errors = {},
    } = validateAge(data.month, data.day, data.year);

    const dateKey = [
      data.month ? "M" : "",
      data.day ? "D" : "",
      data.year ? "Y" : "",
    ].join("");

    if (!status && !dateKey) {
      setErrorBirthday(error);
      simplyClick("err_lnd_age_nodate");
      return;
    }

    if (errorEventsBirthday[dateKey]) {
      setErrorBirthday(error);
      simplyClick(errorEventsBirthday[dateKey]);
      return;
    }

    if (!status) {
      setErrorBirthday(error);
      simplyClick("err_lnd_age_nodate");
      return;
    }

    if (errors.invalidDate) {
      setErrorBirthday(error);
      return;
    }

    if (!status) {
      setErrorBirthday(error);
      return;
    }

    setErrorBirthday(null);

    setData({
      ...data,
      birthday: getBirthdayInFormat(data.year, data.month, data.day),
    });

    simplyClick("cl_lnd_cd3_date_birth_next");
    setStep(step + 1);
  };

  const handlerStepBack = () => {
    simplyClick("cl_lnd_cd3_date_birth_back");
    setStep(step - 1);
  };

  const handleAddMonth = ({ target: { value } }) => {
    setErrorBirthday(null);
    simplyClick("cl_lnd_cd3_date_birth_month_choose", null);

    setData({ ...data, month: value });
  };

  const handleAddDay = ({ target: { value } }) => {
    setErrorBirthday(null);
    simplyClick("cl_lnd_cd3_date_birth_day_choose", null);

    setData({ ...data, day: value });
  };

  const handleAddYear = ({ target: { value } }) => {
    setErrorBirthday(null);
    simplyClick("cl_lnd_cd3_date_birth_year_choose  ", null);

    setData({ ...data, year: value });
  };

  return (
    <div className="global__form-wrap">
      <div className="birthday__form">
        <h5 className="form__title">Please state your date of birth.*</h5>
        <div>
          <div className="date__wrapper">
            <SelectGlobal
              dateArray={getMonths()}
              data={data?.month}
              handleChange={handleAddMonth}
              customClass={"month"}
              label={"Month"}
              errorBirthday={errorBirthday}
            />
            <SelectGlobal
              dateArray={getDate()}
              data={data?.day}
              handleChange={handleAddDay}
              customClass={"day"}
              label={"Day"}
              errorBirthday={errorBirthday}
            />
            <SelectGlobal
              dateArray={getYears()}
              data={data?.year}
              handleChange={handleAddYear}
              customClass={"year"}
              label={"Year"}
              errorBirthday={errorBirthday}
            />
          </div>
          {errorBirthday && <p className="error-text">{errorBirthday}</p>}
        </div>

        <div className="global__text">
          By proceeding you confirm that you are fully legally capable to use
          website and major or at least 18 years old
        </div>
      </div>
      <ButtonGroup cbStepNext={handlerSubmit} cbStepBack={handlerStepBack} />
    </div>
  );
};
export default Birthday;
